export const blockBuilderCommon = {
  key: 'blockBuilderCommon',
  name: 'Block builder Common',
  siteIdentifier: 'global',

  nameRequiredValidationMessage: 'Name is a required field.',
  emailValidationMessage: 'Please re-check your email address.',
  emailRequiredValidationMessage: 'We need a complete valid email address.',
  postalCodeRequiredValidationMessage: 'Postal Code is a required field.',
  postalCodeLengthValidationMessage:
    'Postal code must be at least 5 characters.',
};

export const blockBuilderContentCardComponent = {
  key: 'blockBuilderContentCardComponent',
  name: 'Block Builder Content Card Component',
  siteIdentifier: 'global',

  searchForDealerButton: 'Search for a dealer',
};

export const blockBuilderFeatureRowComponent = {
  key: 'blockBuilderFeatureRowComponent',
  name: 'Block Builder Feature Row Component',
  siteIdentifier: 'global',
  featuredRowSectionAlt: 'Featured Row Section',
};

export const blockBuilderPrivacyPolicyComponent = {
  key: 'blockBuilderPrivacyPolicyComponent',
  name: 'Block Builder Privacy Policy Component',
  siteIdentifier: 'global',

  privacyPolicyHeader: 'Privacy Policy',
  contentsHeader: 'Contents',
  documentWasLastUpdated: 'This document was last updated {date}.',
};

export const blockBuilderProductsComparisonGridComponent = {
  key: 'blockBuilderProductsComparisonGridComponent',
  name: 'Block Builder Products Comparison Grid Component',
  siteIdentifier: 'global',

  selectDealerForInformationHeader:
    'Select your local dealer to see options and pricing information.',
  searchDealersButton: 'Search Dealers',
  unavailableButton: 'Unavailable',
  addToCartButton: 'Add to Cart',
  unavailableAriaLabel: 'Unavailable',
  addToCartAriaLabel: 'Add to Cart',
  callYourLocalDealerButton: 'Call your local dealer',
};

export const blockBuilderBirdeyeReviewWidgetComponent = {
  key: 'blockBuilderBirdeyeReviewWidgetComponent',
  name: 'Block Builder Birdeye Review Widget Component',
  siteIdentifier: 'global',

  customerReviewsHeader: 'Customer reviews',
};

export const blockBuilderDealerDataComponent = {
  key: 'blockBuilderDealerDataComponent',
  name: 'Block Builder Dealer Data Component',
  siteIdentifier: 'global',

  notYourDealerLink: 'Not your dealer? Search again.',
  searchForYourDealerLink: 'Search for your dealer.',
};

export const blockBuilderImageWithHorizontalTextListComponent = {
  key: 'blockBuilderImageWithHorizontalTextListComponent',
  name: 'Block Builder Image With Horizontal Text List Component',
  siteIdentifier: 'global',

  iconImageAlt: 'Icon Image',
};

export const blockBuilderSubscriptionGridComponent = {
  key: 'blockBuilderSubscriptionGridComponent',
  name: 'Block Builder Subscription Grid Component',
  siteIdentifier: 'global',

  useValidEmailAddressValidationMessage:
    'Please use a valid email address such as user@example.com',
  errorOccuredDuringSubscriptionMessage: `Oops! An error occurred during the subscription process. 
        Please {link} and request a new activation link be sent to your email by tapping
        "Activate Collar" and then "Resend Email".`,
  returnToInvisibleFenceAppLink: 'return to the Invisible Fence app',
  weApologizeForInconvenienceMessage:
    'We apologize for the inconvenience and thank you for your cooperation!',
};

export const blockBuilderTestimonialCarouselComponent = {
  key: 'blockBuilderTestimonialCarouselComponent',
  name: 'Block Builder Testimonial Carousel Component',
  siteIdentifier: 'global',

  previousTestimonialsAriaLabel: 'Previous testimonials',
  nextTestimonialsAriaLabel: 'Next testimonials',
};

export const blockBuilderReferralFormComponent = {
  key: 'blockBuilderReferralFormComponent',
  name: 'Block Builder Referral Form Component',
  siteIdentifier: 'global',

  platformCommunicationErrorMessage:
    'An error occurred communicating with our platform. Please try again later.',
  programUnavailableForRegionErrorMessage:
    'Our referral program is currently not available for your region.',
  zipCodeNotEligibleValidationMessage: 'Not eligible',
  errorMessageTitle: "We're Sorry",
  unlessSpecifiedAllFieldsRequiredHint: 'Unless specified, all fields required',
  companyLabel: 'Company',
  emailLabel: 'Email',
  zipCodeLabel: 'Zip Code',
  zipCodeHint: '5 digits',
  phoneNumberLabel: 'Mobile Phone',
  phoneNumberFormatHint: '###-###-####',
  enrollInProgramButton: 'Enroll in Program',
  copyrightFirstLineMessage:
    'Terms and conditions apply. Invisible Fence Brand is a registered trademark of PetSafe Brands.',
  copyrightSecondLineMessage: '© {year} PetSafe Brands. All Rights Reserved.',
  companyRequiredValidationMessage: 'Company required',
  emailIsRequiredValidationMessage: 'Email is required',
  useValidEmailAddressValidationMessage: 'Please use a valid email address',
  zipCodeFormatMismatchValidationMessage:
    'Entered value does not match US zip code format',
  useValidPhoneNumberValidationMessage:
    'Please use a valid 10-digit phone number',

  youAreAllSetSuccessMessageHeader: "You're All Set!",
  referralCodeInfoMessage:
    "Below is your unique referral code. Share this with others and they can save {discountAmount} on their Invisible Fence® system*. Then, you'll receive a {discountAmount} Visa Gift Card after their qualifying system has been installed. To lookup your unique code later, visit the {link}.",
  referralCodeInfoMessageLink: 'referral program page in your online account',
  shareReferralLinkWithFriendsHeader: 'Share my referral link with friends',
  howItWorksHeader: 'How it works:',
  spreadLoveListItem:
    '{label} Share your code with friends, family, clients, or anyone you think would love Invisible Fence® Brand.',
  spreadLoveListItemLabel: 'Spread the love:',
  petSafetyForLessListItem:
    "{label} When the person you referred uses your unique referral code when scheduling their free consultation with us, they'll receive a {discountAmount} discount on their system. (*Not combinable with other offers or discounts, eligible packages and participating dealers only) .",
  petSafetyForLessListItemLabel: 'Pet safety for less:',
  reapYourRewardsListItem:
    "{label} As a thank you for helping us in our mission of protecting pets, we'll automatically email you a {discountAmount} Visa Gift Card via email when your referral has their system installed.",
  reapYourRewardsListItemLabel: 'Reap your rewards:',
};

export const blockBuilderProspectSchedulerComponent = {
  key: 'blockBuilderProspectSchedulerComponent',
  name: 'Block Builder Prospect Scheduler Component',
  siteIdentifier: 'global',

  streetAddressLabel: 'Address',
  appointmentConfirmationWeApologizeHeader: 'We apologize!',
  errorSchedulingAppointmentMessage:
    'There was an error scheduling your {appointmentType} appointment.',
  callUsToScheduleAppointmentMessage:
    'Please call us at {link} to schedule your appointment.',

  congratulationsHeader: 'Congratulations',
  successfullyScheduledAppointmentMessage:
    'You have successfully scheduled your {appointmentType} appointment for {date}',
  appointmentLengthInfoMessage: 'Most of our appointments take about 1 hour.',
  callUsWhenNeededMessage:
    'If you have any questions or need to reschedule, please call us at {link}',
  thankYouForChoosingUsMessage:
    'Thank you for choosing Invisible Fence® Brand. We look forward to meeting you and your pet!',
  alreadyHaveAccountHeader:
    'It looks like you already have an account with us.',
  weCanHelpIfHavingProblemsMessage:
    'Having problems with your existing system? We can help!',
  additionalEmailMessage: 'You will receive an email with additional details.',
  contactUsMessage:
    '{pageLink}  or call us at {phoneLink} to speak with a customer agent.',
  contactUsMessagePageLink: 'Click here to schedule service',
  wannaUpgradeSystemQuestion:
    'Recently moved into a new home, need a major layout change, or looking to upgrade your system?',
  clickHereForAssistanceLink: 'Click here for assistance',
  contactUsForGeneralInquiriesMessage:
    'For all other general inquiries, please {link} to contact us.',
  contactUsForGeneralInquiriesLink: 'click here',

  thankYouHeader: 'Thank you',
  dealerNotifiedMessage:
    '{dealerName} has received your consultation request and will be in touch soon.',
  contactDealersForQuestionsMessage:
    'If you have any questions, please call them at {link}.',

  appointmentDateLabel: 'Appointment Date',
  selectDayPlaceholder: 'Select a day',
  appointmentTimeLabel: 'Appointment Time',
  selectTimePlaceholder: 'Select a time',

  availableConsultationTypesLabel: 'Available Consultation Types',
  inHomeLabel: 'In-Home',
  invisibleFenceInstallationLabel: 'Invisible Fence Installation',
  errorFetchingAppointmentsMessage: 'Error fetching appointments',
  postalCodeIsRequiredMessage: 'Postal code is required',
  contactCustomerServiceErrorMessage:
    'Error scheduling appointment. Please contact customer service.',
  selectValidTimeSlot: 'Please select a valid time slot',
  errorAlertTitle: 'Error',
  noDealersErrorTitle: "We're sorry",
  noDealersErrorMessage: 'There are currently no dealers in your region.',
  unlessSpecifiedAllFieldsRequiredMessage:
    'Unless specified, all fields are required.',
  fetchingDealersStatusText: 'Fetching dealers...',
  fetchingAppointmentsStatusText: 'Fetching appointments...',
  noAppointmentsAvailableMessage:
    'Sorry, there are no appointments available for this dealer. Please contact customer service if you require further information.',
  scheduleAppointmentButton: 'Schedule Appointment',

  dealerSelectServiceAreasLabel: 'Service Areas: ',
  availableDealersLabel: 'Available Dealers',
  selectDealerLabel: 'Select a dealer',

  appointmentDateRequiredValidationMessage: 'Appointment date is required',
  dealerSelectionRequiredValidationMessage: 'Dealer selection is required',
  emailRequiredValidationMessage: 'Email is required',
  useValidEmailAddressValidationMessage: 'Please use a valid email address',
  firstNameRequiredValidationMessage: 'First name is required',
  lastNameRequiredValidationMessage: 'Last name is required',
  useValidPhoneNumberValidationMessage:
    'Please use a valid 10-digit phone number',
  addressRequiredValidationMessage: 'Address is required',
  firstNameLabel: 'First Name',
  lastNameLabel: 'Last Name',
  emailAddressLabel: 'Email Address',
  phoneNumberLabel: 'Phone Number',
  referralCodeLabel: 'Referral Code',
  buttonLoadingText: 'Loading',
  buttonSubmitText: 'Continue',
  optionalLabel: 'Optional',
  yourLocalDealerLabel: 'Your local dealer',
  appointmentLengthLabel: 'All consultations last approximately one hour.',
  appointmentTypeEfenceLabel: 'A pet expert will visit you at your home.',
  appointmentTypeVirtualLabel: 'Speak with a pet expert via video call.',
  appointmentTypeVirtual: 'Virtual',
  appointmentTypeEfence: 'In-Home',
  welcomeBackMessage: 'Welcome Back!',
  estimatedAppointmentMessage: 'Estimated appointment length is',
  weHaveYourInfoMessage:
    'We have your information and will contact you in 1-2 business days to schedule your free consultation.',
  needToScheduleAppointmentMessage: 'Need to schedule an appointment?',
  logInToAccountMessage:
    'Log in to your {accountLink} or call us at {phoneLink}.',
  confirmedInHomeConsultation:
    ' Your in-home consultation with {dealer} has been scheduled for:',
  confirmedVirtualConsultation:
    ' Your virtual consultation with {dealer} has been scheduled for:',
  weLookForwardToAssistingYouMessage: 'We look forward to assisting you!',
  immediateAssistanceMessage:
    "If you need immediate assistance, please call {dealer} at {phone}. We're happy to help.",
  questionsBlockMessageCompanyOwnedDealer:
    'Have questions? Our US-based customer care team is here to assist you. Give us a call at {phoneNumber} or {chatButton} with us today.',
  questionsBlockMessageNonCompanyOwnedDealer:
    'Have questions? The {dealerName} team is here to assist you. Give us a call at {phoneNumber}.',
  consentText:
    'By continuing, I consent to receive communications from PetSafe Brands™ regarding my consultation request. These may include auto-generated calls, texts, and emails. Standard message and data rates may apply. PetSafe Brands™ may share my information with my local authorized dealer as described in its {privacyPolicyLink}. You can opt out at any time by contacting us at {phoneLink} or using the options within our communications. Consent is not a condition of purchase.',
  startChatText: 'start a chat',
};
